var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-center" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.object.isRowSelected,
          expression: "object.isRowSelected",
        },
      ],
      attrs: {
        type: "checkbox",
        "aria-label": "Select row",
        disabled: !!_vm.object.rmProceduresCount,
      },
      domProps: {
        checked: Array.isArray(_vm.object.isRowSelected)
          ? _vm._i(_vm.object.isRowSelected, null) > -1
          : _vm.object.isRowSelected,
      },
      on: {
        change: function ($event) {
          var $$a = _vm.object.isRowSelected,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 &&
                _vm.$set(_vm.object, "isRowSelected", $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                _vm.$set(
                  _vm.object,
                  "isRowSelected",
                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                )
            }
          } else {
            _vm.$set(_vm.object, "isRowSelected", $$c)
          }
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }